import { useEffect } from "react";

// Per-route SEO. The static head in public/index.html carries the homepage
// defaults (the floor for non-JS crawlers); this component UPDATES those
// same tags in place per route — no duplicate title/description/canonical
// tags, no extra head library. On the deployed site the prerender toggle
// serves this rendered head to crawlers.
const SITE = "https://wearposso.com.au";

function setMeta(key, name, value) {
  let el = document.head.querySelector(`meta[${key}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function Seo({ title, description, path = "/", jsonLd = null }) {
  const url = `${SITE}${path}`;
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    let ld = null;
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }
    return () => {
      if (ld) ld.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, url]);
  return null;
}
